import changeFileProperties from './changeFileProperties';
import dataUrlToFile from './dataUrlToFile';
import errorHandling from './errorHandling';
import getNumberByAddress from './getNumberByAddress';
import getStreetByAddress from './getStreetByAddress';
import mediaQuery from './mediaQuery';
import successHandling from './successHandling';

export default {
  dataUrlToFile,
  errorHandling,
  getNumberByAddress,
  getStreetByAddress,
  mediaQuery,
  successHandling,
  changeFileProperties,
};
